import isLength from 'validator/lib/isLength';

export type SurveyExportFormat = 'responses' | 'spss';

export const buildNewQuestion = (questionNo: number) => {
  const ordinal =
    Number.isFinite(questionNo) && questionNo > 0 ? Math.floor(questionNo) : 1;

  return {
    questionType: 'text' as const,
    questionNo: ordinal,
    questionName: `問題 ${ordinal}`,
  };
};

export const isValidQuestionName = (
  questionName: unknown,
  maxLength = 100
): questionName is string =>
  typeof questionName === 'string' &&
  questionName.trim().length > 0 &&
  isLength(questionName, { min: 1, max: maxLength });

export const buildSurveyExportFallbackFilename = (
  surveyName: unknown,
  exportFormat: SurveyExportFormat = 'responses'
): string => {
  const normalizedSurveyName =
    typeof surveyName === 'string' && surveyName.trim().length > 0
      ? surveyName.trim()
      : '問卷';
  const safeSurveyName = normalizedSurveyName.replace(/[\\/:*?"<>|%]/g, '_');
  const suffix = exportFormat === 'spss' ? 'spss' : '問卷資料';

  return `${safeSurveyName}_${suffix}.xls`;
};
